import React, {useState, useEffect} from 'react'
import Loading from '../../Commons/Loading/Loading';
import FooterFormulario from '../../Commons/FooterFormulario/FooterFormulario'
import { Link } from 'react-router-dom';

import DivisionBanner from '../../DivisionContainer/DivisionBanner/DivisionBanner';
import { Modal } from 'react-bootstrap'

import '../../../Styles/main.scss'
import '../DivisionesDetalles.scss'

const StillPipe = () => {

    const [loading, setLoading] = useState(true);
    const [show, setShow] = useState(false);

    const [imgUrl, setImgUrl] = useState('');
    const [txtDes, setDesc] = useState('');

    const handleClose = () => {
        setShow(false);
    };
    
    const handleShow = (paramUrl, paramDesc) => {
        
        setImgUrl(paramUrl)
        setDesc(paramDesc)
        setShow(true)
        
        console.log(paramUrl, ', ', paramDesc);
    };

    useEffect(()=> {
        setTimeout(()=>{
            setLoading(false)
        }, 1000)
    })

    if(loading) {return <Loading />}

    return (

        <section className='container-fluid p-0 containerBlock' > 


            <Modal
              show={show}
              size='lg'
              onHide={handleClose}
              backdrop="static"
              keyboard={false}
            >
              <Modal.Header closeButton>
                <Modal.Title>Se realizan tubos para medición, sondeo manual y radar.</Modal.Title>
              </Modal.Header>

              <Modal.Body>
                <img src={imgUrl} alt="Modal de la imagen amplicada." className='d-block modal__size text-center' loading='lazy' />
              </Modal.Body>

              <Modal.Footer>
                <small >{txtDes}</small>
              </Modal.Footer>
            </Modal>

            <div className='divisionItem__container animated fast fadeIn'>
                <img src="../images/headers/headers-still-pipe.jpg" 
                    alt="Realizamos tubos para medición, sondeo manual y radar." 
                    loading='lazy'
                    className='divisionItem__container--img'    
                />

                <div className='divisionItem__container--textos divisionItem__container--textos-2-lineas' >
                    <h3 className='divisionItem__container--header'>DIVISION</h3>
                    <h1 className='divisionItem__container--title'>CONSTRUCCION Y REPARACION DE TANQUES</h1>
                </div>

            </div>

            <div className='container-fluid divisionItem__detail'>
                <div className='container animated fast fadeIn'>
                <Link to={'/construccion-reparacion-tanques/'}>
                <small> 
                    <i className="fas fa-angle-double-left" style={{'paddingBottom':'15px', 'paddingRight': '10px'}} ></i> 
                    Volver a Division</small>
                </Link>

                <div className='row'>
                    <div className='col-md-6'> 
                        
                        <img 
                            src="../images/divisiones/construccion-reparacion-tanques/still-pipe/still-pipe-12.jpg" 
                            alt="Realizamos tubos para medición, sondeo manual y radar."
                            className='d-block w-100 divisionItem__detail--header'
                            loading='lazy'
                        /> 
                    </div>

                    <div className='col-md-6 divisionItem__detail--block'>
                        <h1 className='divisionItem__detail--title' >Still Pipe</h1>
                        <p  className='divisionItem__detail--text' > 
                        Se realizan tubos para medición, sondeo manual y radar. Ambos tubos son diseñados, construidos y montados bajo requerimiento del cliente. Se ejecutan los elementos correspondientes a esta línea para su perfecto funcionamiento como la bandeja de operaciones, elementos para nivelación, etc. <br /><br />
                        Los tubos son realizados con ranuras y orificios interpuestos, bocas de sondeo CV (tapa pefow), vinculación al tanque con soporteria en envolvente, chapa de refuerzo y datum plate entre otros.<br /><br />
                        Los tubos son inspeccionados y aprobados por compañías externas que se encuentran reguladas y certificadas. 

                        </p> 
                        
                    </div>

                </div>

                <div className='gallery__cont'>

                    <div className='gallery__cont--column'>
                        <img    onClick={ () => handleShow('../images/divisiones/construccion-reparacion-tanques/still-pipe/still-pipe-01.jpg', 'Se realizan tubos para medición, sondeo manual y radar. ') } src='../images/divisiones/construccion-reparacion-tanques/still-pipe/still-pipe-01.jpg' alt='Realizamos tubos para medición, sondeo manual y radar.' loading='lazy'/>
                        <img    onClick={ () => handleShow('../images/divisiones/construccion-reparacion-tanques/still-pipe/still-pipe-02.jpg', 'Se realizan tubos para medición, sondeo manual y radar. ') } src='../images/divisiones/construccion-reparacion-tanques/still-pipe/still-pipe-02.jpg' alt='Realizamos tubos para medición, sondeo manual y radar.' loading='lazy' />
                       
                    </div>

                    <div className='gallery__cont--column'>
                        <img    onClick={ () => handleShow('../images/divisiones/construccion-reparacion-tanques/still-pipe/still-pipe-04.jpg', 'Se realizan tubos para medición, sondeo manual y radar. ') } src='../images/divisiones/construccion-reparacion-tanques/still-pipe/still-pipe-04.jpg' alt='Realizamos tubos para medición, sondeo manual y radar.' loading='lazy' />
                        <img    onClick={ () => handleShow('../images/divisiones/construccion-reparacion-tanques/still-pipe/still-pipe-05.jpg', 'Se realizan tubos para medición, sondeo manual y radar. ') } src='../images/divisiones/construccion-reparacion-tanques/still-pipe/still-pipe-05.jpg' alt='Realizamos tubos para medición, sondeo manual y radar.' loading='lazy' />
                       
                    </div>

                    <div className='gallery__cont--column'>
                        
                        <img    onClick={ () => handleShow('../images/divisiones/construccion-reparacion-tanques/still-pipe/still-pipe-08.jpg', 'Se realizan tubos para medición, sondeo manual y radar. ') } src='../images/divisiones/construccion-reparacion-tanques/still-pipe/still-pipe-08.jpg' alt='Realizamos tubos para medición, sondeo manual y radar.' loading='lazy' />
                        <img    onClick={ () => handleShow('../images/divisiones/construccion-reparacion-tanques/still-pipe/still-pipe-12.jpg', 'Se realizan tubos para medición, sondeo manual y radar. ') } src='../images/divisiones/construccion-reparacion-tanques/still-pipe/still-pipe-12.jpg' alt='Realizamos tubos para medición, sondeo manual y radar.' loading='lazy' /> 
                        <img    onClick={ () => handleShow('../images/divisiones/construccion-reparacion-tanques/still-pipe/still-pipe-06.jpg', 'Se realizan tubos para medición, sondeo manual y radar. ') } src='../images/divisiones/construccion-reparacion-tanques/still-pipe/still-pipe-06.jpg' alt='Realizamos tubos para medición, sondeo manual y radar.' loading='lazy' /> 
                       
                    </div>

                    <div className='gallery__cont--column'>
                        <img    onClick={ () => handleShow('../images/divisiones/construccion-reparacion-tanques/still-pipe/still-pipe-07.jpg', 'Se realizan tubos para medición, sondeo manual y radar. ') } src='../images/divisiones/construccion-reparacion-tanques/still-pipe/still-pipe-07.jpg' alt='Realizamos tubos para medición, sondeo manual y radar.' loading='lazy' />
                        <img    onClick={ () => handleShow('../images/divisiones/construccion-reparacion-tanques/still-pipe/still-pipe-11.jpg', 'Se realizan tubos para medición, sondeo manual y radar. ') } src='../images/divisiones/construccion-reparacion-tanques/still-pipe/still-pipe-11.jpg' alt='Realizamos tubos para medición, sondeo manual y radar.' loading='lazy' /> 
                        <img    onClick={ () => handleShow('../images/divisiones/construccion-reparacion-tanques/still-pipe/still-pipe-10.jpg', 'Se realizan tubos para medición, sondeo manual y radar. ') } src='../images/divisiones/construccion-reparacion-tanques/still-pipe/still-pipe-10.jpg' alt='Realizamos tubos para medición, sondeo manual y radar.' loading='lazy' />
                    </div>

                    <div className='gallery__cont--column'>
                       
                        <img    onClick={ () => handleShow('../images/divisiones/construccion-reparacion-tanques/still-pipe/still-pipe-03.jpg', 'Se realizan tubos para medición, sondeo manual y radar. ') } src='../images/divisiones/construccion-reparacion-tanques/still-pipe/still-pipe-03.jpg' alt='Realizamos tubos para medición, sondeo manual y radar.' loading='lazy' />
                       <img    onClick={ () => handleShow('../images/divisiones/construccion-reparacion-tanques/still-pipe/still-pipe-09.jpg', 'Se realizan tubos para medición, sondeo manual y radar. ') } src='../images/divisiones/construccion-reparacion-tanques/still-pipe/still-pipe-09.jpg' alt='Realizamos tubos para medición, sondeo manual y radar.' loading='lazy' />
                        
                    </div> 
                
                </div>
                </div>
            </div>

            <div>

                <h3 className='divisionItem__bajada--tit text-center'>
                   Otras Divisiones
                </h3>

                <div className='row divisionItem__proyectosDestacados p-0'> 
                    <DivisionBanner 
                        division = {'Arenado y pintura'}
                        imgUrl = {'../images/divisiones/division-banners/divisionBanners-arenado-y-pintura.jpg'}
                        linkUrl = {'/construccion-reparacion-tanques/arenado-pintura/'}
                    /> 
                   <DivisionBanner 
                        division = {'Piso: Reparación y Construcción'}
                        imgUrl = {'../images/divisiones/division-banners/divisionBanners-piso-reparacion.jpg'}
                        linkUrl = {'/construccion-reparacion-tanques/piso-reparacion-y-construccion/'}
                    /> 
                    <DivisionBanner 
                        division = {'Techo: Reparación y Construcción'}
                        imgUrl = {'../images/divisiones/division-banners/divisionBanners-techo-reparacion.jpg'}
                        linkUrl = {'/construccion-reparacion-tanques/techo-reparacion-y-construccion/'}
                    /> 
                    <DivisionBanner 
                        division = {'Pead'}
                        imgUrl = {'../images/divisiones/division-banners/divisionBanners-pead.jpg'}
                        linkUrl = {'/construccion-reparacion-tanques/pead/'}
                    /> 
                </div>

            </div>

            <FooterFormulario className='mt-5' />

        </section>
    )
}

export default StillPipe